import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container, Form} from 'react-bootstrap';
import Switch from 'react-switch';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from 'react-datepicker';

class EditLicensee extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        glCode: this.props.ItemList ? this.props.ItemList.glCode : null,
        orgName: this.props.ItemList ? this.props.ItemList.orgName : null,
        city: this.props.ItemList ? this.props.ItemList.city : null,
        landmark: this.props.ItemList ? this.props.ItemList.landmark : null,
        gstin: this.props.ItemList ? this.props.ItemList.gstin : null,
        email:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.email
            : null,

        name:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.name
            : null,
        lname:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.lName
            : null,

        commPer: this.props.ItemList ? this.props.ItemList.commsnPrcntg : null,
        address1: this.props.ItemList ? this.props.ItemList.addr1 : null,
        address2: this.props.ItemList ? this.props.ItemList.addr2 : null,
        zip: this.props.ItemList ? this.props.ItemList.zip : null,
        spocName: this.props.ItemList ? this.props.ItemList.spocName : null,
        spocEmail: this.props.ItemList ? this.props.ItemList.spocEmail : null,
        spocDesign: this.props.ItemList ? this.props.ItemList.spocDsgntn : null,
        spocPhone: this.props.ItemList ? this.props.ItemList.spocPhn : null,
        hqAdd: this.props.ItemList ? this.props.ItemList.hqAddr : null,
        hqFax: this.props.ItemList ? this.props.ItemList.hqFax : null,
        hqEmail: this.props.ItemList ? this.props.ItemList.hqEmail : null,
        hqPhone: this.props.ItemList ? this.props.ItemList.hqPhn : null,
        crno: this.props.ItemList ? this.props.ItemList.crNumber : null,
        gstin: this.props.ItemList ? this.props.ItemList.gstin : null,
        isEnabled: this.props.ItemList ? this.props.ItemList.taxEnble : null,
        taxPercent: this.props.ItemList ? this.props.ItemList.taxPrcntg : null,
        /* crExpirydate: this.props.ItemList
          ? this.props.ItemList.crExpDate.date
          : null, */

        country:
          this.props.ItemList && this.props.ItemList.country
            ? this.props.ItemList.country.id
            : null,
        countryCode:
          this.props.ItemList && this.props.ItemList.country
            ? this.props.ItemList.country.callingCode
            : null,
        currencyId:
          this.props.ItemList && this.props.ItemList.curncyCode
            ? this.props.ItemList.curncyCode.id
            : null,
        mobno:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.mobileNo
            : null,
        currCode:
          this.props.ItemList && this.props.ItemList.curncyCode
            ? this.props.ItemList.curncyCode.iso4217Code
            : null,
        states:
          this.props.ItemList && this.props.ItemList.state
            ? this.props.ItemList.state.id
            : null,
        district:
          this.props.ItemList && this.props.ItemList.district
            ? this.props.ItemList.district.id
            : null,
        id:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.id
            : null,
      },
      isStatechanged: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        //...state.value,
        glCode: nextProps.ItemList && nextProps.ItemList.glCode,
        orgName: nextProps.ItemList && nextProps.ItemList.orgName,
        city: nextProps.ItemList && nextProps.ItemList.city,
        landmark: nextProps.ItemList && nextProps.ItemList.landmark,
        email:
          nextProps.ItemList &&
          nextProps.ItemList.userId &&
          nextProps.ItemList.userId.email,

        commPer: nextProps.ItemList && nextProps.ItemList.commsnPrcntg,
        name:
          nextProps.ItemList &&
          nextProps.ItemList.userId &&
          nextProps.ItemList.userId.name,
        lname:
          nextProps.ItemList &&
          nextProps.ItemList.userId &&
          nextProps.ItemList.userId.lName,
        address1: nextProps.ItemList && nextProps.ItemList.addr1,
        address2: nextProps.ItemList && nextProps.ItemList.addr2,
        zip: nextProps.ItemList && nextProps.ItemList.zip,
        spocName: nextProps.ItemList && nextProps.ItemList.spocName,
        spocEmail: nextProps.ItemList && nextProps.ItemList.spocEmail,
        spocDesign: nextProps.ItemList && nextProps.ItemList.spocDsgntn,
        spocPhone: nextProps.ItemList && nextProps.ItemList.spocPhn,
        hqAdd: nextProps.ItemList && nextProps.ItemList.hqAddr,
        hqFax: nextProps.ItemList && nextProps.ItemList.hqFax,
        hqEmail: nextProps.ItemList && nextProps.ItemList.hqEmail,
        hqPhone: nextProps.ItemList && nextProps.ItemList.hqPhn,
        crno: nextProps.ItemList && nextProps.ItemList.crNumber,
        gstin: nextProps.ItemList && nextProps.ItemList.gstin,
        isEnabled: nextProps.ItemList && nextProps.ItemList.taxEnble,
        taxPercent: nextProps.ItemList && nextProps.ItemList.taxPrcntg,
        /* crExpirydate:
          nextProps.ItemList &&
          dateFormat(nextProps.ItemList.crExpDate, "mediumDate"), */
        country:
          nextProps.ItemList &&
          nextProps.ItemList.country &&
          nextProps.ItemList.country.id,
        countryCode:
          nextProps.ItemList &&
          nextProps.ItemList.country &&
          nextProps.ItemList.country.callingCode,
        mobno:
          nextProps.ItemList &&
          nextProps.ItemList.userId &&
          nextProps.ItemList.userId.mobileNo,
        currencyId:
          nextProps.ItemList &&
          nextProps.ItemList.curncyCode &&
          nextProps.ItemList.curncyCode.id,
        currCode:
          nextProps.ItemList &&
          nextProps.ItemList.curncyCode &&
          nextProps.ItemList.curncyCode.iso4217Code,
        states:
          nextProps.ItemList &&
          nextProps.ItemList.state &&
          nextProps.ItemList.state.id,
        district:
          nextProps.ItemList &&
          nextProps.ItemList.district &&
          nextProps.ItemList.district.id,

        id: nextProps.ItemList && nextProps.ItemList.userId.id,
      },
    });
  }

  handleChange = checked => {
    this.setState({
      isHidden: checked ? false : true,
      value: {
        ...this.state.value,
        isEnabled: checked,
        taxPercent: !checked
          ? 0
          : this.state
              .taxPercent /*To show taxpercent as zero, if we populate it first and then disable tax */,
      },
    });
  };

  onChange = event => {
    let name = event.target.name;
    let val = event.target.value;
    if (name === 'glCode') {
      this.setState({
        value: {...this.state.value, glCode: val},
      });
    } else if (name === 'orgName') {
      this.setState({
        value: {...this.state.value, orgName: val},
      });
    } else if (name === 'city') {
      this.setState({
        value: {...this.state.value, city: val},
      });
    } else if (name === 'landmark') {
      this.setState({
        value: {...this.state.value, landmark: val},
      });
    } else if (name === 'commission_per') {
      this.setState({
        value: {...this.state.value, commPer: val},
      });
    } else if (name === 'name') {
      this.setState({
        value: {...this.state.value, name: val},
      });
    } else if (name === 'lname') {
      this.setState({
        value: {...this.state.value, lname: val},
      });
    } else if (name === 'address1') {
      this.setState({
        value: {...this.state.value, address1: val},
      });
    } else if (name === 'address2') {
      this.setState({
        value: {...this.state.value, address2: val},
      });
    } else if (name === 'zip') {
      this.setState({
        value: {...this.state.value, zip: val},
      });
    } else if (name === 'spoc_name') {
      // console.log(value);
      this.setState({
        value: {...this.state.value, spocName: val},
      });
    } else if (name === 'spoc_email') {
      this.setState({
        value: {...this.state.value, spocEmail: val},
      });
    } else if (name === 'spoc_desig') {
      this.setState({
        value: {...this.state.value, spocDesign: val},
      });
    } else if (name === 'spoc_phone') {
      this.setState({
        value: {...this.state.value, spocPhone: val},
      });
    } else if (name === 'hq_add') {
      this.setState({
        value: {...this.state.value, hqAdd: val},
      });
    } else if (name === 'hq_fax') {
      this.setState({
        value: {...this.state.value, hqFax: val},
      });
    } else if (name === 'hq_email') {
      this.setState({
        value: {...this.state.value, hqEmail: val},
      });
    } else if (name === 'hq_phone') {
      this.setState({
        value: {...this.state.value, hqPhone: val},
      });
    } else if (name === 'crno') {
      this.setState({
        value: {...this.state.value, crno: val},
      });
    } else if (name === 'gstin') {
      this.setState({
        value: {...this.state.value, gstin: val},
      });
    } else if (name === 'country') {
      /* else if (name === "crExpirydate") {
      this.setState({
        value: { ...this.state.value, crExpirydate: val },
      });
    } */ let countryDetails = JSON.parse(
        val
      );
      // console.log(countryDetails);
      this.setState({
        value: {
          ...this.state.value,
          country: countryDetails.countryId.id,
          currCode:
            countryDetails.currencyId && countryDetails.currencyId.iso4217Code,
          currencyId: countryDetails.currencyId && countryDetails.currencyId.id,
          countryCode:
            countryDetails.countryId && countryDetails.countryId.callingCode,
        },
      });
    } else if (name === 'mobno') {
      this.setState({
        value: {...this.state.value, mobno: val},
      });
    } else if (name === 'states') {
      this.setState(
        {
          value: {...this.state.value, states: val},
        },
        () => {
          this.props.fetchDistrictById(val);
        }
      );
    } else if (name === 'district') {
      this.setState({
        value: {...this.state.value, district: val},
      });
    } else if (name === 'taxPercent') {
      this.setState({
        value: {...this.state.value, taxPercent: val},
      });
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        glCode: this.props.ItemList ? this.props.ItemList.glCode : null,
        orgName: this.props.ItemList ? this.props.ItemList.orgName : null,
        city: this.props.ItemList ? this.props.ItemList.city : null,
        landmark: this.props.ItemList ? this.props.ItemList.landmark : null,
        gstin: this.props.ItemList ? this.props.ItemList.gstin : null,
        email:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.email
            : null,

        name:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.name
            : null,
        lname:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.lName
            : null,

        commPer: this.props.ItemList ? this.props.ItemList.commsnPrcntg : null,
        address1: this.props.ItemList ? this.props.ItemList.addr1 : null,
        address2: this.props.ItemList ? this.props.ItemList.addr2 : null,
        zip: this.props.ItemList ? this.props.ItemList.zip : null,
        spocName: this.props.ItemList ? this.props.ItemList.spocName : null,
        spocEmail: this.props.ItemList ? this.props.ItemList.spocEmail : null,
        spocDesign: this.props.ItemList ? this.props.ItemList.spocDsgntn : null,
        spocPhone: this.props.ItemList ? this.props.ItemList.spocPhn : null,
        hqAdd: this.props.ItemList ? this.props.ItemList.hqAddr : null,
        hqFax: this.props.ItemList ? this.props.ItemList.hqFax : null,
        hqEmail: this.props.ItemList ? this.props.ItemList.hqEmail : null,
        hqPhone: this.props.ItemList ? this.props.ItemList.hqPhn : null,
        crno: this.props.ItemList ? this.props.ItemList.crNumber : null,
        gstin: this.props.ItemList ? this.props.ItemList.gstin : null,
        isEnabled: this.props.ItemList ? this.props.ItemList.taxEnble : null,
        taxPercent: this.props.ItemList ? this.props.ItemList.taxPrcntg : null,
        /* crExpirydate: this.props.ItemList
          ? this.props.ItemList.crExpDate.date
          : null, */

        country:
          this.props.ItemList && this.props.ItemList.country
            ? this.props.ItemList.country.id
            : null,
        countryCode:
          this.props.ItemList && this.props.ItemList.country
            ? this.props.ItemList.country.callingCode
            : null,
        currencyId:
          this.props.ItemList && this.props.ItemList.curncyCode
            ? this.props.ItemList.curncyCode.id
            : null,
        currCode:
          this.props.ItemList && this.props.ItemList.curncyCode
            ? this.props.ItemList.curncyCode.iso4217Code
            : null,
        mobno:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.mobileNo
            : null,
        states:
          this.props.ItemList && this.props.ItemList.state
            ? this.props.ItemList.state.id
            : null,
        district:
          this.props.ItemList && this.props.ItemList.district
            ? this.props.ItemList.district.id
            : null,
        id:
          this.props.ItemList && this.props.ItemList.userId
            ? this.props.ItemList.userId.id
            : null,
      },
    });
    this.props.closeEditModel();
  };

  submit = () => {
    let data = this.state.value;
    console.log(data);

    this.props.EditLicensee(this.state.value);
    this.closeModel();
    this.props.resetPage();
  };

  render() {
    if (
      this.props.districtById === '' ||
      this.props.districtById === undefined ||
      this.props.districtById === null
    ) {
      this.props.fetchDistrictById(this.state.value.states);
    }
    return (
      <div>
        <Modal
          show={this.props.showEditModel}
          onHide={this.closeModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
            closeButton
          >
            <Modal.Title>Edit Licensee Details</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="fname">
                      <Form.Label className="mandatoryField">
                        First Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={this.state.value.name}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.fnameError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="lname">
                      <Form.Label className="mandatoryField">
                        Last Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="lname"
                        value={this.state.value.lname}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.lnameError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Form.Group as={Row} controlId="email">
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label className="mandatoryField">
                      Email ID
                    </Form.Label>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Control
                      readonly={true}
                      value={this.state.value.email}
                    />
                  </Col>
                </Form.Group> */}

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="orgName">
                      <Form.Label className="mandatoryField">
                        Organization Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="orgName"
                        value={this.state.value.orgName}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.orgNameError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="country">
                      <Form.Label className="mandatoryField">
                        Country
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="country"
                        onChange={this.onChange}
                        // value={this.state.value.country}
                      >
                        {/* <option value="select">Select Country</option>
                        {this.props.cntrycrncyList &&
                          this.props.cntrycrncyList.map((item, i) => (
                            <option key={i} value={JSON.stringify(item)}>
                              {item.countryId !== null && item.countryId.name}
                            </option>
                          ))} */}

                        {this.props.cntrycrncyList &&
                          this.props.cntrycrncyList.map(
                            (item, i) =>
                              //Showing the selected country, by matching with the itemID
                              this.state.value.country == item.countryId.id &&
                              <option key={i} value={JSON.stringify(item)}>
                                {item.countryId !== null && item.countryId.name}
                              </option>
                          )}
                        {/* Showing the other countries other than the selected one */}
                        {this.props.cntrycrncyList &&
                          this.props.cntrycrncyList.map(
                            (item, i) =>
                              this.state.value.country !== item.countryId.id &&
                              <option key={i} value={JSON.stringify(item)}>
                                {item.countryId !== null && item.countryId.name}
                              </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.countryError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="states">
                      <Form.Label className="mandatoryField">State</Form.Label>
                      <Form.Control
                        as="select"
                        name="states"
                        onChange={this.onChange}
                      >
                        {this.props.statesList &&
                          this.props.statesList.map(
                            (item, i) =>
                              //Showing the selected state, by matching with the itemID
                              this.state.value.states === item.id &&
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                          )}
                        {/* Showing the other states other than the selected state */}
                        {this.props.statesList &&
                          this.props.statesList.map(
                            (item, j) =>
                              this.state.value.states !== item.id &&
                              <option key={j} value={item.id}>
                                {item.name}
                              </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.statesError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="district">
                      <Form.Label className="mandatoryField">
                        District
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="district"
                        onChange={this.onChange}
                      >
                        {/* <option value="select">Select District</option>
                        {this.props.districtById &&
                          this.props.districtById.map((item, i) => (
                            <option key={i} value={item.id}>
                              {item.name}
                            </option>
                          ))} */}
                        {this.props.districtById &&
                          this.props.districtById.map(
                            (item, i) =>
                              //Showing the selected district, by matching with the itemID
                              this.state.value.district == item.id &&
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                          )}
                        {/* Showing the other districts other than the selected district */}
                        {this.props.districtById &&
                          this.props.districtById.map(
                            (item, i) =>
                              this.state.value.district !== item.id &&
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.districtError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="city">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        autoComplete="off"
                        value={this.state.value.city}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group>
                      <Form.Label className="mandatoryField">
                        Mobile No
                      </Form.Label>
                      <Row>
                        <Col lg={4} md={4} sm={4} xs={4}>
                          <Form.Control
                            style={{padding: 0}}
                            className="readOnlyStyle"
                            name="cont_code"
                            readOnly={true}
                            value={this.state.value.countryCode}
                          />
                        </Col>
                        <Col lg={8} md={8} sm={8} xs={8}>
                          <Form.Control
                            type="text"
                            name="mobno"
                            autoComplete="off"
                            required={true}
                            value={this.state.value.mobno}
                            readOnly={false}
                            onChange={this.onChange}
                          />
                        </Col>
                      </Row>
                      <div className="errStyle">
                        {this.state.mobnoError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="address1">
                      <Form.Label className="mandatoryField">
                        Address 1
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="address1"
                        autoComplete="off"
                        value={this.state.value.address1}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.address1Error}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="address2">
                      <Form.Label>Address 2</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="address2"
                        value={this.state.value.address2}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="landmark">
                      <Form.Label>Landmark</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="landmark"
                        autoComplete="off"
                        rows="1"
                        value={this.state.value.landmark}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="zip">
                      <Form.Label>Zip Code</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="zip"
                        value={this.state.value.zip}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="glCode">
                      <Form.Label>GL Code</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="glCode"
                        value={this.state.value.glCode}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col> */}
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="gstin">
                      <Form.Label>GSTIN</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="gstin"
                        value={this.state.value.gstin}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="crno">
                      <Form.Label>CR No</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="crno"
                        value={this.state.value.crno}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col> */}
                  {/* <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="crExpirydate">
                      <Form.Label>
                        CR Expiry Date
                      </Form.Label>
                      <br />
                      <div className="datepickerDiv">
                        <DatePicker
                          className="ExpdatePicker"
                          autoComplete="off"
                          selected={this.state.value.crExpirydate}
                          onChange={this.handleDate}
                          name="crExpirydate"
                          dateFormat="dd-MM-yyyy"
                          minDate={this.state.value.crExpirydate}
                        />
                      </div>
                    </Form.Group>
                  </Col> */}
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_name">
                      <Form.Label>Contact Person</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_name"
                        value={this.state.value.spocName}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_desig">
                      <Form.Label>Designation</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_desig"
                        value={this.state.value.spocDesign}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_email">
                      <Form.Label>Contact Email</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_email"
                        value={this.state.value.spocEmail}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_phone">
                      <Form.Label>Contact No(Mobile)</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_phone"
                        value={this.state.value.spocPhone}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_add">
                      <Form.Label>Headquarters Address</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_add"
                        value={this.state.value.hqAdd}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_fax">
                      <Form.Label>Headquarters Fax</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_fax"
                        value={this.state.value.hqFax}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_email">
                      <Form.Label>Headquarters Email ID</Form.Label>
                      <Form.Control
                        type="email"
                        autoComplete="off"
                        name="hq_email"
                        value={this.state.value.hqEmail}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_phone">
                      <Form.Label>Headquarters Contact No</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_phone"
                        value={this.state.value.hqPhone}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group as={Row} controlId="tax_pay">
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Tax Enable</Form.Label>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Switch
                      onChange={this.handleChange}
                      onColor="#20a8d8"
                      checked={this.state.value.isEnabled}
                    />
                  </Col>
                </Form.Group>

                <Form.Group
                  as={Row}
                  style={{display: this.state.isHidden ? 'none' : null}}
                  controlId="taxPercent"
                >
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label>Tax Percentage</Form.Label>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Control
                      type="number"
                      autoComplete="off"
                      name="taxPercent"
                      min={0}
                      max={100}
                      value={this.state.value.taxPercent}
                      onChange={this.onChange}
                    />
                  </Col>
                </Form.Group>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="curr_code">
                      <Form.Label>Currency Code</Form.Label>
                      <Form.Control
                        className="readOnlyStyle"
                        type="text"
                        name="curr_code"
                        readOnly={true}
                        value={this.state.value.currCode}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="commission_per">
                      <Form.Label>Commission Percentage</Form.Label>
                      <Form.Control
                        type="number"
                        autoComplete="off"
                        min={0}
                        max={100}
                        name="commission_per"
                        value={this.state.value.commPer}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Form.Group controlId="org_logo">
                      <Form.Label>
                        Organization Logo
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="org_logo"
                        accept="image/*"
                        value={this.state.value.orgLogo}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row> */}

                {/* <div className="mb-3">
                  <Form.File id="formcheck-api-regular">
                    <Form.File.Label>Regular file input</Form.File.Label>
                    <Form.File.Input />
                  </Form.File>
                </div> */}
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditLicensee;
